"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMR_OC_REQUIRED_SIGMA_MODEL_TYPES = exports.SUPPORTED_SIGMA_MODEL_TYPES = void 0;
exports.isSupportedSigmaModel = isSupportedSigmaModel;
exports.requiresAmrOcCapture = requiresAmrOcCapture;
exports.isFormFlowSupportedSigmaModelType = isFormFlowSupportedSigmaModelType;
const array_submodels_1 = require("../../../../../PackageStore/ComponentArrays/array-submodels");
exports.SUPPORTED_SIGMA_MODEL_TYPES = [
    'capacitor.nonpolarized',
    'capacitor.polarized',
    'diode.generic',
    'diode.zener',
    'diode.led',
    'diode.multiled',
    'diode.tvs.bidirectional',
    'diode.tvs.unidirectional',
    'ferrite.standard',
    'fuse.generic',
    'fuse.poly',
    'inductor.coupled',
    'inductor.standard',
    'resistor.standard',
    'resistor.thermistor',
    'resistor.variable',
    'resistor.varistor',
    'mosfet.enhancement.ntype',
    'mosfet.enhancement.ptype',
    'transistor.bjt.npn',
    'transistor.bjt.pnp',
    'opamp.generic',
    'passive.array',
];
function isSupportedSigmaModel(sigmaModelType) {
    return exports.SUPPORTED_SIGMA_MODEL_TYPES.includes(sigmaModelType);
}
exports.AMR_OC_REQUIRED_SIGMA_MODEL_TYPES = [
    'mosfet.enhancement.ntype',
    'mosfet.enhancement.ptype',
    'transistor.bjt.npn',
    'transistor.bjt.pnp',
    'opamp.generic',
];
function requiresAmrOcCapture(sigmaModelType) {
    return exports.AMR_OC_REQUIRED_SIGMA_MODEL_TYPES.includes(sigmaModelType);
}
function isFormFlowSupportedSigmaModelType(sigmaModelType, elementSigmaModelType) {
    if (elementSigmaModelType !== '') {
        return (0, array_submodels_1.getArrayElementConfig)(elementSigmaModelType) !== null;
    }
    return isSupportedSigmaModel(sigmaModelType);
}
//# sourceMappingURL=supported-sigma-model-types.js.map